import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=891c0cc4&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=891c0cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891c0cc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
